import * as ko from "knockout";
import entityBase from "entityBase";
import { warranty_defective_part } from "entitiesE";
import { attachment } from "organized";

export class container_line extends entityBase {
  attachment: KnockoutObservable<attachment>;
  c_wty_claim_defective_part: KnockoutObservableArray<warranty_defective_part>;
  request_id: KnockoutObservable<string>;
  device_serial: KnockoutObservable<string>;

  sequences: KnockoutComputed<number[]>;
  request_ids: KnockoutComputed<string[]>;

  constructor(item: any) {
    super();
    this.request_id = ko.observable(item?.request_id);
    this.attachment = <KnockoutObservable<attachment>>this.loadRelation(item, attachment, "attachment");
    this.c_wty_claim_defective_part = <KnockoutObservableArray<warranty_defective_part>>(
      this.loadRelation(item, warranty_defective_part, "c_wty_claim_defective_part", "array")
    );

    this.sequences = ko.computed(() => {
      const sequences =
        this.c_wty_claim_defective_part()
          ?.map((part) => part.sequence())
          .filter((seq) => seq != null) ?? [];
      return [...new Set(sequences)].sort((a, b) => a - b);
    });

    this.request_ids = ko.computed(() => {
      const ids =
        this.c_wty_claim_defective_part()
          ?.map((part) => part.request_id())
          .filter((id) => id != null) ?? [];
      return [...new Set(ids)].sort();
    });

    const part = this.c_wty_claim_defective_part().find((part) => part.device_serial_id());
    this.device_serial = ko.observable(part?.device_serial_id());
  }
}
